var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#fff",
    fillOpacity: 0.5,
    r: 15,
    transform: "matrix(-1 0 0 1 30 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#161716"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 9h3v12h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 9h3v12h-3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseButton);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxNSIgY3k9IjE1IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9Ii41IiByPSIxNSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMzAgMCkiLz48ZyBmaWxsPSIjMTYxNzE2Ij48cGF0aCBkPSJtMTAuNSA5aDN2MTJoLTN6Ii8+PHBhdGggZD0ibTE2LjUgOWgzdjEyaC0zeiIvPjwvZz48L3N2Zz4=";